module.exports = __webpack_public_path__ + "img/titleAtive3.0fef08c.webp";